<div *ngIf="loader == false; else elseBlock" class="spinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<ng-template #elseBlock>
  <div class="divHome">
    <div class="header-container">
      <h1>Tablillas por File - Ver Configuración</h1>
      <div class="location-container" *ngIf="location">
        <i-tabler name="map-pin"></i-tabler>
        <h1>{{ getLocation(location) }}</h1>
      </div>
    </div>

    <mat-button-toggle-group
      name="fontStyle"
      aria-label="Font Style"
      class="divButtons"
      style="justify-content: center !important"
    >
      <mat-button-toggle
        [ngClass]="
          selected === null ? 'elementButtonSelected' : 'elementButton'
        "
        (click)="changeValue(null)"
        >ALL</mat-button-toggle
      >

      <mat-button-toggle
        [ngClass]="
          selected === 'HIKING' ? 'elementButtonSelected' : 'elementButton'
        "
        (click)="changeValue('HIKING')"
      >
        HIKING</mat-button-toggle
      >

      <mat-button-toggle
        [ngClass]="
          selected === 'TREKKING' ? 'elementButtonSelected' : 'elementButton'
        "
        (click)="changeValue('TREKKING')"
      >
        TREKKING</mat-button-toggle
      >

      <mat-button-toggle
        [ngClass]="
          selected === 'BIKINGADVENTURES'
            ? 'elementButtonSelected'
            : 'elementButton'
        "
        (click)="changeValue('BIKINGADVENTURES')"
      >
        BIKING</mat-button-toggle
      >
    </mat-button-toggle-group>

    <mat-form-field appearance="fill" class="buttonFilter">
      <mat-label>FILES</mat-label>
      <mat-select
        [(value)]="selectFile"
        (selectionChange)="applyFilterSelect()"
      >
        <mat-option value="{{ null }}">No seleccionar</mat-option>
        <mat-option *ngFor="let file of arrayFiles" value="{{ file }}">{{
          file
        }}</mat-option>
      </mat-select>
    </mat-form-field>

    <div style="display: flex; justify-content: center; margin-top: 1rem">
      <mat-form-field appearance="outline" class="divInputSearch">
        <!-- <mat-label>Filtrar</mat-label> -->
        <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar " />
      </mat-form-field>
    </div>
    <div class="divTable">
      <div
        class="example-container mat-elevation-z8"
        style="
          width: 100%;
          margin: auto;
          display: flex;
          justify-content: center;
          flex-direction: column;
        "
        class="divButtons"
      >
        <table *ngIf="loader" style="border: 1px #989898 solid">
          <thead>
            <tr>
              <th>FILE</th>
              <th>SERVICIO</th>
              <th>CATEGORIA PRODUCTO</th>
              <th>SUB CATEGORIA PRODUCTO</th>
              <th>CREACIÓN</th>
              <th>ACTUALIZACIÓN</th>
              <th *ngFor="let f of paxHeader; let i = index">
                PAX {{ i + 1 }}
              </th>
            </tr>
          </thead>

          <tr *ngFor="let row of dataFilter; let i = index">
            <td>{{ row.file }}</td>
            <td>{{ row.servicio }}</td>
            <td>{{ row.categoriaProducto }}</td>
            <td>{{ row.subCategoriaProducto }}</td>
            <td>{{ row.createdAt | date: "dd/MM/yyyy" }}</td>
            <td>{{ row.updatedAt | date: "dd/MM/yyyy" }}</td>
            <td *ngFor="let p of row.pax; let in = index; let last = last">
              {{ p.numPax ? p.numPax : "-" }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</ng-template>
